import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

/** A partner row with its message-channel preferences (PartnerMessageType). */
export interface PartnerMessageRow {
  partnerId: number;
  partnerName?: string | null;
  partnerCode?: string | null;
  contactPerson?: string | null;
  email?: string | null;
  phone?: string | null;
  /** null => the partner has no channel row yet (treat as defaults / all-off). */
  messageTypeId?: number | null;
  isWhatsApp: boolean;
  isSMS: boolean;
  isEmail: boolean;
  // Message-type toggles (which kinds of message to send). Default on.
  isPaymentReceipt: boolean;
  isCoi: boolean;
  isOtp: boolean;
  isPaymentLink: boolean;
  isPolicyIssued: boolean;
  isKyc: boolean;
}

/** Upsert payload for a partner's channels + message types. */
export interface SaveMessageRequest {
  partnerId: number;
  isWhatsApp: boolean;
  isSMS: boolean;
  isEmail: boolean;
  isPaymentReceipt: boolean;
  isCoi: boolean;
  isOtp: boolean;
  isPaymentLink: boolean;
  isPolicyIssued: boolean;
  isKyc: boolean;
}

@Injectable({ providedIn: 'root' })
export class PartnerMessageService {
  private http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiUrl}/PartnerMessage`;

  /** `search` matches name / code / phone. */
  getAll(search?: string) {
    const params = search ? { search } : undefined;
    return this.http.get(`${this.baseUrl}/GetAll`, params ? { params } : {});
  }

  getByPartner(partnerId: number) {
    return this.http.get(`${this.baseUrl}/GetByPartner`, { params: { partnerId } });
  }

  /** Insert or update the partner's channel row. */
  save(body: SaveMessageRequest) {
    return this.http.post(`${this.baseUrl}/Save`, body);
  }
}
